import { Supplier } from '@customTypes';

export const sortSuppliers = (suppliers: Supplier[]) => suppliers.sort((a, b) => a.seq - b.seq);
